<div class="mt-6 h-full">
  @if (strategy(); as strategy) {
    <app-targeting-asin-stats
      class="h-full"
      [isReadOnly]="isReadOnly()"
      [strategy]="strategy"
      [withTOSROSwitch]="withTOSROSwitch()"
    />
  }
</div>
